<template>
    <div id="invoice">
        <!-- ------------------------------電子發票設置開始------------------------------ -->
        <section class="cm-depositcenter-invoice-section">
            <div class="container-fluid p-0">
                <div class="row no-gutters">
                    <div class="col">
                        <img class="img-fluid" :src=imageUrl>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-start justify-content-center mb-4 cm-triangle">
                <div class="cm-triangle-font">
                    {{$t('invoice.InvoiceBar')}}
                </div>
            </div>

            <form>
                <div class="cm-depositcenter-invoice-container">
                    <div class="row cm-invoice-items">
                        <div
                            class="col-3 px-0 d-flex justify-content-center align-items-center text-nowrap cm-invoice-item"
                             @click="changeTab('tab1')">
                            <a>{{$t('invoice.tab1')}}</a>
                        </div>
                        <div
                            class="col-3 px-0 d-flex justify-content-center align-items-center text-nowrap cm-invoice-item"
                            @click="changeTab('tab2')">
                            <a>{{$t('invoice.tab2')}}</a>
                        </div>
                        <div
                            class="col-3 px-0 d-flex justify-content-center align-items-center text-nowrap cm-invoice-item"
                            @click="changeTab('tab3')">
                            <a>{{$t('invoice.tab3')}}</a>
                        </div>
                        <div
                            class="col-3 px-0 d-flex justify-content-center align-items-center text-nowrap cm-invoice-item"
                            @click="changeTab('tab4')">
                            <a>{{$t('invoice.tab4')}}</a>
                        </div>
                    </div>
                    <div class="row cm-invoice-contents">
                        <!-- ----------------------------載具管理開始---------------------------- -->
                        <div class="col p-3 p-md-5 cm-invoice-carrier"
                        v-show="tabController=='tab1'">
                            <div class="cm-invoice-title mb-4">{{$t('invoice.tab1.Title1')}}</div>
                            <div class="cm-invoice-text">
                                <p>
                                    {{$t('invoice.tab1.Title1.text1_1')}}                                    
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab1.Title1.text1_2')}}
                                </p>
                                <p>
                                    {{$t('invoice.tab1.Title1.text2_1')}}                                    
                                    <a @click="goToMemberCarrierHome">{{$t('invoice.common.invoiceConsolidation')}}</a>
                                    {{$t('invoice.tab1.Title1.text2_2')}}
                                </p>
                                <p>
                                   {{$t('invoice.tab1.Title1.text3_1')}}    
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab1.Title1.text3_2')}}
                                </p>
                            </div>
                            <div class="cm-invoice-text">
                                <p>{{$t('invoice.tab1.Title1.text4')}}</p>
                                <p>{{$t('invoice.tab1.Title1.text5')}}</p>
                                <p>{{$t('invoice.tab1.Title1.text6')}}</p>
                                <p>{{$t('invoice.tab1.Title1.text7')}}</p>
                            </div>
                            <div class="cm-invoice-title">{{$t('invoice.tab1.Title2')}}</div>
                            <div class="cm-invoice-carrier-border-bottom">
                                <div class="cm-invoice-text">
                                    <select class="form-control form-control-lg cm-invoice-carrier-select"
                                    v-model="carriers.selectCarrier">
                                        <option :value="carriers.phoneCarrier.value">{{$t('invoice.tab1.Title2.PhoneCarriers')}}</option>
                                        <option :value="carriers.certificateCarrier.value">{{$t('invoice.tab1.Title2.CertificateCarriers')}}</option>
                                        <option :value="carriers.CMCarrier.value">{{$t('invoice.tab1.Title2.CMCarriers')}}</option>
                                        <!--<option>個人紙本發票(三聯式)</option>-->
                                    </select>
                                    <!-- -------手機條碼載具-------- -->
                                    <div name="carrierContent" v-show="carriers.selectCarrier==carriers.phoneCarrier.value">
                                        <div class="cm-invoice-text">{{$t('invoice.tab1.Title2.PhoneANDCertificate.Text')}}</div>
                                        <div class="col-12 row p-0 form-group">
                                            <div class="col-12 col-xl-3 col-lg-4 col-md-4 text-nowrap">
                                                {{$t('invoice.tab1.Title2.PhoneCarriers.Input')}}
                                            </div>
                                            <div class="col-12 col-xl-6 col-lg-5 col-md-6 col-sm-9">
                                                <input class="form-control" type="text" v-model="carriers.phoneCarrier.inputPhoneBarcode">
                                            </div>
                                        </div>
                                        <div class="cm-invoice-text-promote">{{$t('invoice.tab1.Title2.PhoneCarriers.Promote')}}</div>
                                    </div>
                                    <!-- -------自然人憑證載具-------- -->
                                    <div name="carrierContent"  v-show="carriers.selectCarrier==carriers.certificateCarrier.value"
                                        style="display:none;">
                                        <div class="cm-invoice-text">{{$t('invoice.tab1.Title2.PhoneANDCertificate.Text')}}</div>
                                        <div class="col-12 row p-0 form-group">
                                            <div class="col-12 col-xl-3 col-lg-4 col-md-4 text-nowrap">
                                                {{$t('invoice.tab1.Title2.CertificateCarriers.Input')}}
                                            </div>
                                            <div class="col-12 col-xl-6 col-lg-5 col-md-6 col-sm-9">
                                                <input class="form-control" type="text" v-model="carriers.certificateCarrier.inputCertificate">
                                            </div>
                                        </div>
                                        <div class="cm-invoice-text-promote">{{$t('invoice.tab1.Title2.CertificateCarriers.Promote')}}</div>
                                    </div>
                                    <!-- -------台遊會員載具-------- -->
                                    <div name="carrierContent"  v-show="carriers.selectCarrier==carriers.CMCarrier.value" style="display:none;">
                                        <div class="cm-invoice-text">{{$t('invoice.tab1.Title2.CMCarriers.Text')}}</div>
                                        <div class="col-12 row p-0 form-group">
                                            <div class="col-12 col-xl-2 col-lg-2 col-md-3 text-nowrap">
                                                {{$t('invoice.tab1.Title2.CMCarriers.Input.Phone')}}
                                            </div>
                                            <div class="col-9 col-xl-6 col-lg-5 col-md-6 col-sm-9">
                                                <input class="form-control" type="text" v-model="carriers.CMCarrier.inputInvoicePhone">
                                            </div>
                                            {{$t('invoice.tab1.Title2.CMCarriers.Input.Must')}}
                                        </div>
                                        <div class="col-12 row p-0 form-group">
                                            <div class="col-12 col-xl-2 col-lg-2 col-md-3 text-nowrap">
                                                {{$t('invoice.tab1.Title2.CMCarriers.Input.Name')}}
                                            </div>
                                            <div class="col-9 col-xl-6 col-lg-5 col-md-6 col-sm-9">
                                                <input class="form-control" type="text" v-model="carriers.CMCarrier.inputInvoiceReceiver">
                                            </div>
                                            {{$t('invoice.tab1.Title2.CMCarriers.Input.Must')}}
                                        </div>
                                        <div class="col-12 row p-0 form-group">
                                            <div class="col-12 col-xl-2 col-lg-2 col-md-3 text-nowrap">
                                                {{$t('invoice.tab1.Title2.CMCarriers.Input.Address')}}
                                            </div>
                                            <div class="col-9 col-xl-6 col-lg-5 col-md-6 col-sm-9">
                                                <input class="form-control" type="text" v-model="carriers.CMCarrier.inputInvoiceAddress">
                                            </div>
                                            {{$t('invoice.tab1.Title2.CMCarriers.Input.Must')}}
                                        </div>
                                        <div class="cm-invoice-text-promote">
                                            {{$t('invoice.tab1.Title2.CMCarriers.Promote')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-center">
                                    <a href="#" class="cm-invoice-carrier-submit" @click.prevent="submitCarrierContent">
                                        {{$t('invoice.tab1.Title2.Submit')}}
                                    </a>
                                </div>
                                <div class="text-center cm-invoice-text">
                                    <span>{{$t('invoice.tab1.Title2.SaveText')}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- ----------------------------載具管理結束--------------------------- -->
                        <!-- ----------------------------發票查詢開始--------------------------- -->
                        <div class="col p-3 p-md-5 cm-invoice-list cmv-invoice-listcontent"
                        v-show="tabController=='tab2'">
                            <div class="cm-invoice-title mb-4">{{$t('invoice.tab2.Title')}}</div>
                            <div class="row no-gutters pb-3 cm-invoice-query">
                                <div class="col-9 row no-gutters cm-invoice-query-select">
                                    <div class="col-12 col-md-4 d-flex align-items-center row no-gutters">
                                        <input class="col-2 cm-invoice-query-checkbox" type="checkbox"
                                            :id="invoiceSearchRangeType.currentInvoice.value"
                                            :value="invoiceSearchRangeType.currentInvoice.value"
                                            @change="checkboxSelect"
                                            v-model="invoiceSearchRangeType.invoiceSearchRangeValue">
                                        <label :for="invoiceSearchRangeType.currentInvoice.value" class="m-0 ml-1 col cm-invoice-query-label">
                                            {{$t('invoice.tab2.Query.CurrentInvoice')}}
                                        </label>
                                    </div>
                                    <div class="col-12 col-md-4 d-flex align-items-center row no-gutters">
                                        <input class="col-2 cm-invoice-query-checkbox" type="checkbox"
                                            :id="invoiceSearchRangeType.earlyInvoice.value"
                                            :value="invoiceSearchRangeType.earlyInvoice.value"
                                            @change="checkboxSelect"
                                            v-model="invoiceSearchRangeType.invoiceSearchRangeValue">
                                        <label :for="invoiceSearchRangeType.earlyInvoice.value" class="m-0 ml-1 col cm-invoice-query-label">
                                            {{$t('invoice.tab2.Query.EarlyInvoice')}}
                                        </label>
                                    </div>
                                    <div class="col-12 col-md-4 d-flex align-items-center row no-gutters">
                                        <input class="col-2 cm-invoice-query-checkbox" type="checkbox"
                                            :id="invoiceSearchRangeType.allInvoice.value"
                                            :value="invoiceSearchRangeType.allInvoice.value"
                                            @change="checkboxSelect"
                                            v-model="invoiceSearchRangeType.invoiceSearchRangeValue"
                                            data-period="all">
                                        <label :for="invoiceSearchRangeType.allInvoice.value" class="m-0 ml-1 col cm-invoice-query-label">
                                            {{$t('invoice.tab2.Query.AllInvoice')}}
                                        </label>
                                    </div>
                                </div>
                                <div class="col-3 d-flex align-items-center justify-content-center">
                                    <a class="cm-invoice-query-btn"
                                    @click="ajaxSearchEInvoiceForFrontend">
                                        {{$t('invoice.tab2.Query.Btn')}}
                                    </a>
                                </div>
                            </div>
                            <!-- 發票搜尋Table -->
                            <div id="haveData" v-if="isShowInvoiceListTable==true" @click="clickInvoiceListTable($event)">
                                <b-row class="my-3 cmv-invoice-listcontent-table-top">
                                    <!-- search -->
                                    <div class="col-md-2">
                                        {{$t('invoice.tab2.Filter')}}
                                    </div>
                                    <div class="col-md-4 cmv-invoice-listcontent-table-filter">
                                        <b-input-group>
                                            <b-form-input v-model="filter" :placeholder="$t('invoice.tab2.Filter.Search.Placeholder')" />
                                            <b-input-group-append>
                                                <b-button :disabled="!filter" @click="filter = ''">{{$t('invoice.tab2.Filter.Search.Clear')}}</b-button>
                                            </b-input-group-append>
                                        </b-input-group>
                                    </div>

                                    <!-- search -->
                                    <div class="col-md-2 offset-md-2">
                                        {{$t('depositHistoryList.result.Per')}}
                                    </div>
                                    <div class="col-md-2 cmv-invoice-listcontent-table-page">
                                        <b-form-group>
                                            <b-form-select :options="pageOptions" v-model="perPage" />
                                        </b-form-group>
                                    </div>
                                </b-row>

                                <b-table class="table table-striped table-bordered cm-invoice-table" 
                                show-empty
                                :items="items" 
                                :fields="setTableFields()" 
                                :current-page="currentPage" 
                                :per-page="perPage" 
                                :sort-by.sync="sortBy" 
                                :sort-desc.sync="sortDesc" 
                                :filter="filter" 
                                @filtered="onFiltered" 
                                style="word-wrap:break-word; word-break: break-all">
                                    
                                    <!-- 標題 -->
                                    <template v-slot:cell(invoiceid)="data">
                                        <span v-html="data.value"></span>
                                    </template>
                                </b-table>

                                <b-row>
                                    <b-col>
                                        <b-pagination align="center"
                                        :total-rows="totalRows"
                                        :per-page="perPage"
                                        v-model="currentPage"
                                        class="cmv-invoice-listcontent-table-pagination" />
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col align="center">
                                        {{$t('depositHistoryList.result.Total')}} {{totalRows}} {{$t('depositHistoryList.result.Record')}}
                                    </b-col>
                                </b-row>
                            </div>


                            <div v-if="isShowInvoiceListTable==false" class="cmv-invoice-listcontent-no-data">
                                <table class="cmv-invoice-listcontent-inquire-result">
                                    <tr>
                                        <th>{{$t('invoice.tab2.Table.TransactionNumber')}}</th>
                                        <th>{{$t('invoice.tab2.Table.InvoiceNumber')}}</th>
                                        <th>{{$t('invoice.tab2.Table.Money')}}</th>
                                        <th>{{$t('invoice.tab2.Table.Date')}}</th>
                                        <th>{{$t('invoice.tab2.Table.Type')}}</th>
                                        <th>{{$t('invoice.tab2.Table.Remarks')}}</th>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </table>
                            </div>


                            <div class="cm-invoice-text">
                                <p>{{$t('invoice.tab2.Promote.Title')}}</p>
                                <p>{{$t('invoice.tab2.Promote.Text1')}}</p>
                                <p>{{$t('invoice.tab2.Promote.Text2')}}</p>
                                <p>
                                    {{$t('invoice.tab2.Promote.Text3')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab2.Promote.Text4')}}
                                </p>
                                <p>{{$t('invoice.tab2.Promote.Text5')}}</p>
                            </div>
                        </div>
                        <!-- ----------------------------發票查詢結束--------------------------- -->
                        <!-- ----------------------------流程說明開始--------------------------- -->
                        <div class="col p-3 p-md-5 cm-invoice-process"
                        v-show="tabController=='tab3'">
                            <div class="cm-invoice-title mb-4">{{$t('invoice.tab3.Title')}}</div>
                            <div class="row d-flex justify-content-center align-items-center">
                                <img class="pt-3 cm-invoice-process-img" src="@/assets/images/invoice/flow-chart.png">
                            </div>

                        </div>
                        <!-- ----------------------------流程說明結束--------------------------- -->
                        <!-- ------------------------------FAQ開始----------------------------- -->
                        <div class="col p-3 p-md-5 cm-invoice-faq"
                        v-show="tabController=='tab4'">
                            <div class="cm-invoice-title">FAQ</div>
                            <div class="cm-invoice-text">
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title1')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer1.Text')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    。
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title2')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer2.Text')}}
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title3')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer3.Text1')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab4.QA.Answer3.Text2')}}
                                </p>
                                <p>{{$t('invoice.tab4.QA.Answer3.Text3')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>{{$t('invoice.tab4.QA.Answer3.Text4')}}
                                </p>
                                
                                <p>{{$t('invoice.tab4.QA.Answer3.Text5')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab4.QA.Answer3.Text6')}}
                                    <span class="cm-invoice-faq-symbol">
                                        {{$t('invoice.tab4.QA.Answer3.Text7')}}
                                    </span>
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title4')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer4.Text1')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab4.QA.Answer4.Text2')}}
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title5')}}</p>
                                <p>{{$t('invoice.tab4.QA.Answer5.Text')}}</p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title6')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer6.Text1')}}
                                    <a href="https://www.einvoice.nat.gov.tw/index" target="_blank">{{$t('invoice.common.einvoice')}}</a>
                                    {{$t('invoice.tab4.QA.Answer6.Text2')}}
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title7')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer7.Text1')}}
                                    <a href="mailto:service@all9fun.com">service@all9fun.com</a>
                                    {{$t('invoice.tab4.QA.Answer7.Text2')}}
                                    <span class="cm-invoice-faq-symbol">{{$t('invoice.tab4.QA.Answer7.Text3')}}</span>
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title8')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer8.Text')}}
                                </p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title9')}}</p>
                                <p>{{$t('invoice.tab4.QA.Answer9.Text')}}</p>
                                <p class="cm-invoice-faq-title">{{$t('invoice.tab4.QA.Title10')}}</p>
                                <p>
                                    {{$t('invoice.tab4.QA.Answer10.Text1')}}
                                    <a href="//www.all9fun.com/#/contactus" target="_blank">{{$t('invoice.tab4.QA.Answer10.Text2')}}</a>
                                    {{$t('invoice.tab4.QA.Answer10.Text3')}}
                                </p>
                            </div>
                        </div>
                        <!-- ------------------------------FAQ結束----------------------------- -->
                    </div>
                </div>
            </form>
        </section>
        <!-- ------------------------------電子發票設置結束------------------------------ -->
        <!------------------------------電子發票Modal開始------------------------------>
        <div class="modal fade cm-modal" id="invoiceModal" tabindex="-1" role="dialog"
            aria-labelledby="invoiceModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered cm-modal-invoice" role="document">
                <div class="modal-content" style="display:block;" v-html="invoiceModalHTMLContent">
                </div>
            </div>
        </div>
        <div id="invoiceHyperlink" style="display:none;"></div>
        <!------------------------------電子發票Modal結束------------------------------>

    </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import router from '@/router.js'
import CookieUtil from '@/assets/js/util/CookieUtil.js'
import InvoiceUtil from "@/assets/js/util/InvoiceUtil.js";
import store from '@/store/store-controller/store.js'
import * as BackendSetting from "@/assets/js/util/BackendSetting.js";
import eventBus from '@/assets/js/event/EventBus.js'
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'

export default {
    name: "invoice",
    data() {
        return {
            tabController: "tab1", // 控制頁籤
            invoice: {
                donationInvoice: { // 發票捐贈(伊甸、家扶、創世...等等)
                    value: "DonationInvoice",
                    invoiceType: "1"
                },
                personalInvoice: { // 電子發票(個人)
                    value: "PersonalInvoice",
                    invoiceType: "2"
                },
                GUINumberInvoice: { // 電子發票(統編)
                    value: "GUINumberInvoice",
                    invoiceType: "3"
                }
            },
            carriers: {
                selectCarrier: "phoneCarrier",
                phoneCarrier: {
                    value: "phoneCarrier",
                    carrierType: "3J0002",
                    inputPhoneBarcode: ""
                },
                certificateCarrier: {
                    value: "certificateCarrier",
                    carrierType: "CQ0001",
                    inputCertificate: ""
                },
                CMCarrier: {
                    value: "CMCarrier",
                    carrierType: "EG0379",
                    inputInvoiceReceiver: "", // 收件人姓名
                    inputInvoiceAddress: "",
                    inputInvoicePhone: ""
                }
            },
            invoiceSearchRangeType: {
                invoiceSearchRangeValue: [],
                selectInvoiceType: "",
                allInvoice: { // 所有發票
                    value: "allInvoice",
                    queryType: "3"
                },
                earlyInvoice: { // 前期未中獎發票
                    value: "earlyInvoice",
                    queryType: "2"
                },
                currentInvoice: { // 當期未開獎發票
                    value: "currentInvoice",
                    queryType: "1"
                }
            },
            imageUrlDefault: require("@/assets/images/game/gametitle.jpg"),
            imageUrl: require("@/assets/images/game/gametitle.jpg"),
            isShowInvoiceListTable: true,
            sortBy: 'orderid',
            sortDesc: true,
            currentPage: 1,
            perPage: 5,
            pageOptions: [5, 10, 15],
            items: [],
            totalRows: 0,
            filter: null,
            invoiceModalHTMLContent: ""
        }
    },
    mounted() {
        const self = this;
        this.updateTopBackgroundImg();

        // 更換語言時
        eventBus.$on(process.env.VUE_APP_EVENT_EMIT_CHANGE_LANGUAGE_ROUTER_INVOICE, function(i18n) {
            self.updateTopBackgroundImg(i18n);
        });

        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_SWITCH_PAGE_SHOW_ITEMS , false);
        
        // 驗證是否為登入狀態，未登入狀態則顯示loginModal讓玩家登入，玩家登入完畢後再回來
        let verifySetting = {
            verifyStatus: true, // 驗證登入
            from: router.currentRoute.name, // 來源頁面
            setFrontendRouterPushCookie: true, // 是否設置cookie方便登入會導回from設置的頁面
            showLoginModal: true // 未登入狀態下顯示loginModal
        };
        eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_VERIFY_LOGIN, verifySetting);


        if(CookieUtil.getCookie(process.env.VUE_APP_COOKIE_FRONTEND_ID_COOKIE) !== false) {
            this.isShowInvoiceListTable = false;
            this.init();
        }
    },
    methods: {
        init() {
            let self = this;

            // 此頁面重刷時需等待login成功後，後端回傳相關資料再進行後續步驟
            let timeoutTs = parseInt(new Date().getTime()) + parseInt(process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND);
            let waitLogin = setInterval(() => {
                let nowTs = new Date().getTime();
                if(nowTs > timeoutTs) {
                    clearInterval(waitLogin);
                }
                else if (store.getters['storeMemberInfo/getNum'] != undefined && store.getters['storeMemberInfo/getNum']!=""){
                    clearInterval(waitLogin);
                    self.ajaxGetInvoiceMemberCarrier();
                }
            }, 500);
        },
        async updateTopBackgroundImg(i18n = this.$i18n) {
            // 更新上方背景圖
            let imageUrl = await BackendSetting.getTopBackgroundImgUrl(i18n.locale);
            this.imageUrl = (imageUrl != "" ? imageUrl : this.imageUrlDefault);
        },
        changeTab(TabName)
        {
            this.tabController = TabName;
        },
        checkboxSelect()
        {
            // checkBox只能勾選一個
            if(this.invoiceSearchRangeType.invoiceSearchRangeValue.length>1)
            {
                this.invoiceSearchRangeType.invoiceSearchRangeValue.splice(0,1);
            }
            this.invoiceSearchRangeType.selectInvoiceType = this.invoiceSearchRangeType.invoiceSearchRangeValue[0];
        },
        setTableFields()
        {
            return [
                {
                    key: 'orderid',
                    label: this.$i18n.t('invoice.tab2.Table.TransactionNumber'),
                    sortable: true
                },
                {
                    key: 'invoiceid',
                    label: this.$i18n.t('invoice.tab2.Table.InvoiceNumber'),
                    sortable: true
                },
                {
                    key: 'amount',
                    label: this.$i18n.t('invoice.tab2.Table.Money'),
                    sortable: true
                },
                {
                    key: 'createdate',
                    label: this.$i18n.t('invoice.tab2.Table.Date'),
                    sortable: true
                },
                {
                    key: 'invoicetype',
                    label: this.$i18n.t('invoice.tab2.Table.Type'),
                    sortable: true
                },
                {
                    key: 'remark',
                    label: this.$i18n.t('invoice.tab2.Table.Remarks'),
                    sortable: true
                }
            ];
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = this.items.length;
            this.currentPage = 1;
        },
        clickInvoiceListTable(event) {
            if(event.target.dataset.invoicedetail == "invoicedetail") {
                this.showInvoiceModal(event)
            }
        },
        async showInvoiceModal(event) {
            this.invoiceModalHTMLContent = "";

            let invoiceNumber = event.target.dataset.invoicenumber;
            if(invoiceNumber==undefined || invoiceNumber=="") {
                alert("error!");
                return;
            }
            const response = await this.ajaxGetEInvoiceInfo(invoiceNumber);
            if(response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
                let jsonResult = response.data;
                if(jsonResult.result == "success") {
                    let orderid = event.target.dataset.orderid;
                    let message = JSON.parse(response.data.message);
                    this.invoiceModalHTMLContent = `
                        <div class="modal-body p-3">
                            <p>${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.TransactionNumber')}${orderid}</p>
                            <p>${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.InvoiceType')}${message.invoiceForm}</p>
                    `
                    this.invoiceModalHTMLContent += `
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.Company')}</p>
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.InvoiceNumber')}${message.invoiceNumber}</p>
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.InvoiceDateFormat')}${message.invoiceDateFormat}</p>
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.RandomNumber')}${message.randomNumber}</p>
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.GoodsName')}${message.invoiceAmount}</p>
                    `
                    // 發票型態為3(電子發票(統編))且統編欄位(invoiceCompanyNumber)不為空
                    if(message.invoiceType==this.invoice.GUINumberInvoice.invoiceType && message.invoiceCompanyNumber!=undefined && message.invoiceCompanyNumber!="") {
                        this.invoiceModalHTMLContent += `
                            <p class="col-12">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Invoice.InvoiceCompanyNumber')}${message.invoiceCompanyNumber}</p>
                        `
                    }
                    if(message.printMark=="Y") { // 已經索取發票
                        this.invoiceModalHTMLContent += `
                            <p class="cm-modal-invoice-attention">
                                ${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Remind.PrintMark')}
                            </p>
                        `
                    }
                    else if(message.invoiceType == this.invoice.donationInvoice.invoiceType) { // 發票類型為捐贈
                        let str = this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Remind.DonationInvoice');
                        let receivedFullName = InvoiceUtil.getLoveCodeAndName(message.donateNpo, this.$i18n.locale);
                        if(receivedFullName!=undefined && receivedFullName!="") {
                            str = str.replace("%s", receivedFullName);
                        }
                        else {
                            let subSentence = this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Remind.DonationInvoice.SubSentence');
                            subSentence = subSentence.replace("%s", message.donateNpo);
                            str = str.replace("%s", subSentence);
                        }

                        this.invoiceModalHTMLContent += `
                            <p class="cm-modal-invoice-attention">
                                ${str}
                            </p>
                        `
                    }
                    /*
                    this.invoiceModalHTMLContent += `
                            <div class="">
                                <div class="row pt-3 m-0">
                                   
                                    <div class="col-6 pl-0 pr-2">
                                        <img class="w-100 mw-100" src="@/assets/images/invoice/receipt01.jpg">
                                    </div>
                                    <div class="col-6 pr-0 pl-2">
                                        <img class="w-100 mw-100" src="@/assets/images/invoice/receipt02.jpg">
                                    </div>
                                     
                                </div>
                            </div>
                    `
                    */
                    this.invoiceModalHTMLContent += `
                            <p class="pt-3">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Remind.EinvoicePhone')}</p>
                            <p>${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Remind.ServiceEmail')}</p>
                            <div class="d-flex justify-content-center p-3">
                                <button class="d-flex justify-content-center align-items-center cm-modal-invoice-close-btn"
                                    data-dismiss="modal">${this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Close')}</button>
                            </div>
                        </div>
                    `
    
                    // DOM方式開啟Modal
                    let aTag = document.createElement("a");
                    aTag.id="aTag";
                    aTag.dataset.toggle = "modal";
                    aTag.dataset.target = "#invoiceModal";
                    document.querySelector("#invoiceHyperlink").innerHTML = "";
                    document.querySelector("#invoiceHyperlink").appendChild(aTag);
                    aTag.click();
                }
                else if(jsonResult.result == "error") {
                    alert(this.$i18n.t('invoice.tab2.Modal.InvoiceDetail.Ajax.Backend.Response.Error'));
                }
            }
        },
        submitCarrierContent() {
            let self = this;
            let bodyFormData = new FormData();
            let carrierObj = {}
            
            if(this.carriers.selectCarrier == this.carriers.phoneCarrier.value) { // 手機載具
                // 驗證手機條碼格式
                let phoneBarcodeErrorMsg = ValidatorUtil.validInvoicePhoneBarcode(this.carriers.phoneCarrier.inputPhoneBarcode, { 'req': this.$i18n.t('invoice.tab1.Title2.PhoneCarriers.Validate.PhoneBarcode.req'), "format": this.$i18n.t('invoice.tab1.Title2.PhoneCarriers.Validate.PhoneBarcode.format') })
                if(phoneBarcodeErrorMsg!="") {
                    alert(phoneBarcodeErrorMsg);
                    return "";
                }
                else {
                    carrierObj.carrierType = this.carriers.phoneCarrier.carrierType;
                    carrierObj.carrierId1 = this.carriers.phoneCarrier.inputPhoneBarcode;
                }
            }
            else if(this.carriers.selectCarrier == this.carriers.certificateCarrier.value) { // 自然人憑證
                // 驗證手機條碼格式
                let certificateErrorMsg = ValidatorUtil.validInvoiceCertificate(this.carriers.certificateCarrier.inputCertificate, { 'req': this.$i18n.t('invoice.tab1.Title2.CertificateCarriers.Validate.Certificate.req'), "format": this.$i18n.t('invoice.tab1.Title2.CertificateCarriers.Validate.Certificate.format') })
                if(certificateErrorMsg!="") {
                    alert(certificateErrorMsg);
                    return "";
                }
                else {
                    carrierObj.carrierType = this.carriers.certificateCarrier.carrierType;
                    carrierObj.carrierId1 = this.carriers.certificateCarrier.inputCertificate;
                }
            }
            else if(this.carriers.selectCarrier == this.carriers.CMCarrier.value) { // 會員載具(個人)
                if(this.carriers.CMCarrier.inputInvoiceReceiver == undefined || this.carriers.CMCarrier.inputInvoiceReceiver == "") {
                    alert(this.$i18n.t('invoice.tab1.Title2.CMCarriers.Validate.Receiver.req'));
                    return;
                }
                else if(this.carriers.CMCarrier.inputInvoiceAddress == undefined || this.carriers.CMCarrier.inputInvoiceAddress == "") {
                    alert(this.$i18n.t('invoice.tab1.Title2.CMCarriers.Validate.Address.req'));
                    return;
                }
                else if(this.carriers.CMCarrier.inputInvoicePhone == undefined || this.carriers.CMCarrier.inputInvoicePhone == "") {
                    alert(this.$i18n.t('invoice.tab1.Title2.CMCarriers.Validate.Phone.req'));
                    return;
                }

                // 驗證手機號碼格式
                let phoneErrorMsg = ValidatorUtil.validInvoice10DigisPhone(this.carriers.CMCarrier.inputInvoicePhone, { 'req': this.$i18n.t('invoice.tab1.Title2.CMCarriers.Validate.Phone.req'), "format": this.$i18n.t('invoice.tab1.Title2.CMCarriers.Validate.Phone.format') })
                if(phoneErrorMsg!="") {
                    alert(phoneErrorMsg);
                    return "";
                }
                else {
                    carrierObj.carrierType = this.carriers.CMCarrier.carrierType;
                    carrierObj.invoiceReceiver = this.carriers.CMCarrier.inputInvoiceReceiver;
                    carrierObj.invoiceAddress = this.carriers.CMCarrier.inputInvoiceAddress;
                    carrierObj.invoicePhone = this.carriers.CMCarrier.inputInvoicePhone;
                }
            }
            else {
                alert(this.$i18n.t('invoice.tab1.Title2.Validate.Carriers.req'));
                return;
            }

            if(Object.keys(carrierObj).length>0) {
                // 送出Ajax
                this.ajaxModifyInvoiceMemberCarrier(carrierObj);
            }
        },
        async ajaxGetInvoiceMemberCarrier() {
            let bodyFormData = new FormData();
            bodyFormData.append("fkMemberMultiId", store.getters['storeMemberInfo/getNum']);

            // Ajax取得載具資訊
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getInvoiceMemberCarrierAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            }).catch(function () {
                console.log('Connection failed!');
            });

            if (response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
                let jsonResult = response.data;
                if(jsonResult.result == "success") {
                    let messageArray = JSON.parse(jsonResult.message); // 字串陣列轉陣列
                    for(let i=0; i<messageArray.length; i++) {
                        let messageObj = messageArray[i];
                        // 確認身分
                        if(messageObj.fkMemberMultiId == store.getters['storeMemberInfo/getNum']
                         && messageObj.subAccount == store.getters['storeMemberInfo/getAccount']) {
                            if(messageObj.carrierType == this.carriers.phoneCarrier.carrierType) { // 手機載具
                                this.carriers.phoneCarrier.inputPhoneBarcode = messageObj.carrierId1;
                            }
                            else if(messageObj.carrierType == this.carriers.certificateCarrier.carrierType) { // 自然人憑證
                                this.carriers.certificateCarrier.inputCertificate = messageObj.carrierId1;
                            }
                            else if(messageObj.carrierType == this.carriers.CMCarrier.carrierType) { // 會員載具(個人)
                                this.carriers.CMCarrier.inputInvoiceReceiver = messageObj.invoiceReceiver;
                                this.carriers.CMCarrier.inputInvoiceAddress = messageObj.invoiceAddress;
                                this.carriers.CMCarrier.inputInvoicePhone = messageObj.invoicePhone;
                            }
                        }
                    }
                }
            }
        },
        async ajaxSearchEInvoiceForFrontend() {
            let bodyFormData = new FormData();
            bodyFormData.append("fkMemberMultiId", store.getters['storeMemberInfo/getNum']);
            if(this.invoiceSearchRangeType.selectInvoiceType == this.invoiceSearchRangeType.allInvoice.value) {
                bodyFormData.append("queryType", this.invoiceSearchRangeType.allInvoice.queryType);
            }
            else if(this.invoiceSearchRangeType.selectInvoiceType == this.invoiceSearchRangeType.earlyInvoice.value) {
                bodyFormData.append("queryType", this.invoiceSearchRangeType.earlyInvoice.queryType);
            }
            else if(this.invoiceSearchRangeType.selectInvoiceType == this.invoiceSearchRangeType.currentInvoice.value) {
                bodyFormData.append("queryType", this.invoiceSearchRangeType.currentInvoice.queryType);
            }
            else {
                alert(this.$i18n.t('invoice.tab2.InvoiceSearchRange.Validate.InvoiceSearchRange.req'))
                return;
            }

            // Ajax查詢電子發票
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/searchEInvoiceForFrontendAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            }).catch(function () {
                console.log('Connection failed!');
            });
            
            this.items = [];
            if (response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
                let jsonResult = response.data;
                if(jsonResult.result == "success" && jsonResult.message.length>0) {
                    let messageArray = JSON.parse(jsonResult.message);

                    for(let i=0; i<messageArray.length; i++) {
                        let messageObj = messageArray[i];
                        let renderMessageObj = {};
                        renderMessageObj.orderid = messageObj.depositOrderId;
                        renderMessageObj.invoiceid = `<a data-invoicedetail="invoicedetail" data-orderid="${messageObj.depositOrderId}" data-invoicenumber="${messageObj.invoiceNumber}">${messageObj.invoiceNumber}</a>` ;
                        renderMessageObj.amount = messageObj.invoiceAmount;
                        renderMessageObj.createdate = messageObj.invoiceDateFormat;
                        renderMessageObj.invoicetype = messageObj.invoiceForm;
                        renderMessageObj.remark = messageObj.memoForSearch;
                        this.items.push(renderMessageObj);
                    }
                }
            }
            
            this.currentPage = 1;
            this.totalRows = this.items.length;
            this.isShowInvoiceListTable = (this.items.length>0 ? true : false);
        },
        async ajaxModifyInvoiceMemberCarrier(carrierObj) {

            let bodyFormData = new FormData();
            bodyFormData.append("fkMemberMultiId", store.getters['storeMemberInfo/getNum']);
            bodyFormData.append("subAccount", store.getters['storeMemberInfo/getAccount']);
            // 電子發票資訊
            if(Object.keys(carrierObj).length>0) {
                let keys = Object.keys(carrierObj);
                for(let i=0; i<keys.length; i++) {
                    let key = keys[i];
                    bodyFormData.append(key, carrierObj[key]);
                }
            }

            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/modifyInvoiceMemberCarrierAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            }).catch(function () {
                console.log('Connection failed!');
            });
            
            
            if (response != undefined && response.status == 200 && response.data != undefined) { // ajax成功
                let jsonResult = response.data;
                if(jsonResult.result == "success") {
                    let messageObj = JSON.parse(jsonResult.message);
                    if(messageObj.fkMemberMultiId == store.getters['storeMemberInfo/getNum']) { // 驗證身分
                        alert(this.$i18n.t('invoice.tab1.Title2.Ajax.ModifyMemberCarrier.Backend.Response.success'))
                    }
                    else {
                        alert(this.$i18n.t('invoice.tab1.Title2.Ajax.ModifyMemberCarrier.Backend.Response.error'))
                    }
                }
                else {
                    alert(this.$i18n.t('invoice.tab1.Title2.Ajax.ModifyMemberCarrier.Backend.Response.error'))
                }
            }
        },
        async ajaxGetEInvoiceInfo(invoiceNumber) {
            let bodyFormData = new FormData();
            bodyFormData.append("invoiceNumber", invoiceNumber);
            const response = await axios({
                method: "post",
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/getEInvoiceInfoAction.shtml",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                data: bodyFormData
            }).catch(function () {
                console.log('Connection failed!');
            });

            return response;
        },
        // 點選畫面上的 「發票歸戶」後，將玩家帶到goToMemberCarrierHomeAction，最後帶到財政部的網頁
        goToMemberCarrierHome() {
            const fkMemberMultiId = store.getters['storeMemberInfo/getNum']
            const subAccount = store.getters['storeMemberInfo/getAccount']
            const invoiceReceiver = (this.carriers.CMCarrier.inputInvoiceReceiver == null ? "" : this.carriers.CMCarrier.inputInvoiceReceiver)
            const invoiceAddress = (this.carriers.CMCarrier.inputInvoiceReceiver == null ? "" : this.carriers.CMCarrier.inputInvoiceAddress)
            const invoicePhone = (this.carriers.CMCarrier.inputInvoiceReceiver == null ? "" : this.carriers.CMCarrier.inputInvoicePhone)
            const urlParam = `?fkMemberMultiId=${fkMemberMultiId}&subAccount=${subAccount}&invoiceReceiver=${invoiceReceiver}&invoiceAddress=${invoiceAddress}&invoicePhone=${invoicePhone}`

            // [刪除]測試完畢後刪除
            console.log(urlParam);
            const url = window.location.protocol + process.env.VUE_APP_URL_DOMAIN_LOGIN + "/goToMemberCarrierHomeAction.shtml" + urlParam
            console.log(url);

            window.location.href = url
        }
    },
}
</script>


<style lang="scss">
.cmv-invoice-listcontent {
    .cmv-invoice-listcontent-table-top {
        .cmv-invoice-listcontent-table-filter .input-group {
            input.form-control,
            div.input-group-append button {
                height: 26px;
                font-size: 12px;
                text-align: center;
            }

            input.form-control {
                text-align: center;
            }

            div.input-group-append button {
                padding: 0 10px;
            }
        }

        .cmv-invoice-listcontent-table-page select.custom-select {
            height: 26px;
            font-size: 12px;
            padding: 0 10px;
        }
    }

    .cmv-invoice-listcontent-table-pagination {
        height: auto;
        color: #c6bdc6;
        text-align: center;
        line-height: 50px;
        font-weight: bold;
        margin: 15px auto;
        overflow: hidden;

        a.page-link {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #050a0e;
            color: #c6bdc6;
            text-decoration: none;
            background: rgba(0, 0, 0, 0);
            border-color: rgba(0, 0, 0, 0);
            transition-duration: 0s;
        }

        a.page-link:hover {
            color: #fff;
            background-color: #565656;
            text-decoration: none;
            text-align: center;
        }

        .page-item.active .page-link {
            z-index: 1;
            color: #fff;
            border-color: #007bff;
            background-color: rgba(0, 0, 0, 0) !important;
        }

        .page-item.disabled .page-link {
            background: rgba(0, 0, 0, 0);
            border-color: rgba(0, 0, 0, 0);
        }
    }

    .cmv-invoice-listcontent-no-data {
        background-image: url("../assets/images/nodata.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 80%;
        .cmv-invoice-listcontent-inquire-result {
            border-collapse: collapse;
            width: 100%;
            font-size: 18px;
            td,
            th {
                border: 1px solid #6b6b6b;
                padding: 10px;
            }
            td {
                font-size: 18px;
                text-align: center;
                color: #c3c3c3;
                height: 80px;
                width: 230px;
            }
            th {
                padding-top: 10px;
                padding-bottom: 10px;
                text-align: center;
                background-color: #4f4f52;
                color: #c3c3c3;
                font-size: 22px;
                font-weight: normal;
            }
        }
    }

    @media screen and (min-width: 1px) {
        .cmv-invoice-listcontent-table-pagination {
            .page-item a {
                font-size: 1.4vw;
            }

            .page-link,
            .page-link:hover,
            .page-item.active .page-link {
                height: 5.2vw;
                width: 5.2vw;
                line-height: 2.2vw;
            }
        }
    }

    @media screen and (min-width: 576px) {
        .cmv-invoice-listcontent-table-pagination {
            .page-item a {
                font-size: 1.4vw;
            }

            .page-link,
            .page-link:hover,
            .page-item.active .page-link {
                height: 5.2vw;
                width: 5.2vw;
                line-height: 2.2vw;
            }
        }
    }

    @media screen and (min-width: 767px) {
        .cmv-invoice-listcontent-table-pagination {
            .page-item a {
                font-size: 1.4vw;
            }

            .page-link,
            .page-link:hover,
            .page-item.active .page-link {
                height: 4vw;
                width: 4vw;
                line-height: 2.2vw;
            }
        }
    }

    @media screen and (min-width: 992px) {
        .cmv-invoice-listcontent-table-pagination {
            .page-item a {
                font-size: 1.4vw;
            }

            .page-link,
            .page-link:hover,
            .page-item.active .page-link {
                height: 4vw;
                width: 4vw;
                line-height: 2.2vw;
            }
        }
    }

    @media screen and (min-width: 1200px) {
        .cmv-invoice-listcontent-table-pagination {
            .page-item a {
                font-size: 20px;
            }

            .page-link,
            .page-link:hover,
            .page-item.active .page-link {
                height: 50px;
                width: 50px;
                line-height: 30px;
            }
        }
    }
}
</style>